/**
 * Button — a single interactive action.
 *
 * Variants: primary | secondary | danger
 * States: default, disabled (loading is expressed via `label`, e.g. "Connecting…",
 * so callers control their own pending copy rather than this component guessing it).
 */
export function Button({ label, variant = "secondary", disabled = false, onClick, id }) {
  const el = document.createElement("button");
  el.className = `btn-${variant}`;
  el.textContent = label;
  el.disabled = disabled;
  if (id) el.id = id;
  if (onClick) el.addEventListener("click", onClick);
  return el;
}
